import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=4038da00&scoped=true&"
import script from "./UserList.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4038da00",
  null
  
)

export default component.exports